import { render, staticRenderFns } from "./AdminPermanenceSettings.vue?vue&type=template&id=32ae7f4a"
import script from "./AdminPermanenceSettings.vue?vue&type=script&lang=js"
export * from "./AdminPermanenceSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports